var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRightLong = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 29 29"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.702 21.63a1.17 1.17 0 0 0 1.654 1.653L23.54 15.1a1.17 1.17 0 0 0 0-1.654l-8.184-8.184a1.17 1.17 0 1 0-1.654 1.653l6.189 6.189H6.344a1.17 1.17 0 1 0 0 2.338h13.547z"
})));
export default SvgArrowRightLong;